<template>

<core-config-section>

	<h2>Show Comments <small>Applies to all collections</small></h2>

	<p>Comments are now shown on collections but you can choose to always show them when viewing your profile or all profiles..</p>

	<div class="inputs">

		<core-filter-input-toggles size="2" :labels="['Always Hide', 'All Collections']" :values="[0,2]" :icons="[]" filter="config/collection/comments" v-if="!loggedin" />
		<core-filter-input-toggles size="3" :labels="['Always Hide', 'Own Collection', 'All Collections']" :values="[0,1,2]" :icons="[]" filter="config/collection/comments" v-if="loggedin" />

	</div>

</core-config-section>

</template>

<script>

export default {

}

</script>